<template>
  <div class="header-container">
    <NavigationMenu></NavigationMenu>
    <UserNavigationMenu></UserNavigationMenu>
    <div class="background-wrapper">
      <div class="header-background">
        <div class="header-wrapper">
          <header
            :class="{
              header: true,
              'navigation-topbar-mobile__flyout--hidden':
                activeNav || activeUserNav
            }"
          >
            <div class="header-content">
              <div class="header-icons">
                <div class="icon-wrapper">
                  <div class="icon-context">
                    <div class="menu">
                      <button
                        type="button"
                        @click="toggleNav()"
                        role="button"
                        aria-label="menu"
                        aria-expanded="false"
                        class="menu-button icon-button porsche-radius__small"
                      >
                        <div class="icon">
                          <span class="icon">
                            <vue-fontawesome :icon="['fal', 'bars']" />
                          </span>
                        </div>
                        <span class="label">Menu</span>
                      </button>
                    </div>
                    <div class="logo-container">
                      <div class="navigation-topbar-mobile">
                        <div class="navigation-topbar-mobile__crest">
                          <router-link
                            to="/"
                            class="navigation-topbar-mobile__logo"
                          >
                            <div class="navigation-topbar-mobile__image"></div>
                          </router-link>
                        </div>
                      </div>
                      <div class="logo-wrapper">
                        <router-link to="/" class="logo">
                          <img
                            :src="
                              require('@/assets/img/Porsche_wordmark_white_rgb.svg')
                            "
                            class="header__image"
                          />
                        </router-link>
                      </div>
                    </div>
                    <div class="user">
                      <button
                        type="button"
                        @click="toggleUserNav()"
                        role="button"
                        aria-label="user"
                        aria-expanded="false"
                        class="user-button icon-button porsche-radius__small"
                      >
                        <div class="icon icon--user">
                          <span class="icon">
                            <vue-fontawesome :icon="['fal', 'user']" />
                          </span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Hamburger from './Hamburger';
import MainNavigation from './MainNavigation';
import TopNavigationDesktop from './TopNavigationDesktop';
import TopNavigationMobile from './NavigationMenu';
import NavigationMenu from '@/components/header/NavigationMenu';
import UserNavigationMenu from '@/components/header/UserNavigationMenu';

export default {
  name: 'Header',
  components: {
    UserNavigationMenu,
    NavigationMenu,
    TopNavigationDesktop,
    TopNavigationMobile,
    MainNavigation,
    Hamburger
  },
  methods: {
    ...mapActions(['toggleNav', 'toggleUserNav'])
  },
  computed: {
    ...mapGetters(['activeNav', 'activeUserNav'])
  }
};
</script>

<style lang="scss" scoped>
div.header-container {
  position: absolute;
  width: 100%;
  display: block;
  z-index: 1;
  margin-top: -13px;
}
div.background-wrapper {
  min-height: 4.125rem;

  @media (min-width: 480px) {
    min-height: 5rem;
  }
  @media (min-width: 760px) {
    min-height: 4.5625rem;
  }
  @media (min-width: 1000px) {
    min-height: 4.75rem;
  }
  @media (min-width: 1300px) {
    min-height: 5.125rem;
  }
}

div.header-background {
  --scrollbar-width: 0px;
  display: block;
  visibility: inherit;
}

div.header-wrapper {
  background: linear-gradient(
    to bottom,
    rgba(31, 31, 31, 0.9) 0%,
    rgba(31, 31, 31, 0.9) 20%,
    rgba(31, 31, 31, 0.852589) 26.67%,
    rgba(32, 32, 32, 0.768225) 33.33%,
    rgba(33, 33, 33, 0.668116) 40%,
    rgba(34, 34, 34, 0.557309) 46.67%,
    rgba(35, 35, 35, 0.442691) 53.33%,
    rgba(36, 36, 36, 0.331884) 60%,
    rgba(37, 37, 37, 0.231775) 66.67%,
    rgba(38, 38, 38, 0.147411) 73.33%,
    rgba(39, 39, 39, 0.0816599) 80%,
    rgba(39, 39, 39, 0.03551) 86.67%,
    rgba(39, 39, 39, 0.0086472) 93.33%,
    rgba(39, 39, 39, 0) 100%
  );
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(31, 31, 31, 0.9)),
    color-stop(20%, rgba(31, 31, 31, 0.9)),
    color-stop(26.67%, rgba(31, 31, 31, 0.852589)),
    color-stop(33.33%, rgba(32, 32, 32, 0.768225)),
    color-stop(40%, rgba(33, 33, 33, 0.668116)),
    color-stop(46.67%, rgba(34, 34, 34, 0.557309)),
    color-stop(53.33%, rgba(35, 35, 35, 0.442691)),
    color-stop(60%, rgba(36, 36, 36, 0.331884)),
    color-stop(66.67%, rgba(37, 37, 37, 0.231775)),
    color-stop(73.33%, rgba(38, 38, 38, 0.147411)),
    color-stop(80%, rgba(39, 39, 39, 0.0816599)),
    color-stop(86.67%, rgba(39, 39, 39, 0.03551)),
    color-stop(93.33%, rgba(39, 39, 39, 0.0086472)),
    to(rgba(39, 39, 39, 0))
  );
  background-position: 0 0;

  @media (min-width: 0px) {
    height: 72px;
  }
  @media (min-width: 760px) {
    height: 148px;
  }
}

header.header {
  height: 5.125rem;
  display: grid;
  grid-gap: clamp(16px, calc(1.25vw + 12px), 36px);
  min-width: 320px;
  max-width: 2560px;
  box-sizing: content-box;
  margin: 0 auto;

  @media (min-width: 480px) {
    min-height: 5rem;
  }
  @media (min-width: 760px) {
    min-height: 4.5625rem;
  }
  @media (min-width: 1000px) {
    min-height: 4.75rem;
  }
  @media (min-width: 1300px) {
    min-height: 5.125rem;
  }
}
div.header-content {
  align-items: center;
  justify-content: center;
  display: flex;
  position: relative;
  height: 100%;
  color: $base;
}
div.header-icons {
  position: absolute;
  width: 100%;
  padding: 0 1rem;

  @media (min-width: 760px) {
    padding: 0 1.5rem;
    margin-top: 15px;
  }
  @media (min-width: 1000px) {
    padding: 0 2rem;
  }
  @media (min-width: 1400px) {
    padding: 0 3rem;
  }
}
div.icon-wrapper {
  display: flex;
  flex: 1;
}
div.icon-context {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: 1fr;
  gap: 0 0;
  grid-template-areas: 'left center right';
  width: 100%;
  color: $base;
}
div.menu {
  grid-area: left;
  justify-self: start;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 1rem;
  margin: 0.375rem;
}
button {
  color: $base;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: start;
  gap: 4px;
  padding: 0rem;
  margin: 0;
  background-color: rgba(0, 0, 0, 0);
  outline: none !important;
  border: none;
  width: auto;

  @media (min-width: 760px) {
    font-size: 1rem;
    margin: 0.5rem;
  }
  @media (min-width: 1000px) {
    font-size: 1rem;
  }

  &:hover {
    background-color: #9495982e;
  }
}

.navigation-topbar-mobile {
  height: 4rem;
  position: relative;

  @media (min-width: 480px) {
    display: none;
    visibility: hidden;
  }

  &__crest {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 6.375rem;
    height: 5rem;
    z-index: 1;
  }

  &__logo {
    display: block;
  }

  &__image {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(https://cdn.ui.porsche.com/porsche-design-system/crest/porsche-crest.min.8a292fbd35a5155789ddd011585e05c4@2x.png);
    width: 30px;
    height: 40px;

    @media only screen and (-webkit-min-device-pixel-ratio: 2),
      not all,
      only screen and (min-resolution: 2dppx),
      only screen and (min-resolution: 192dpi) {
      background-image: url(https://cdn.ui.porsche.com/porsche-design-system/crest/porsche-crest.min.8a292fbd35a5155789ddd011585e05c4@2x.png);
    }
  }
}
div.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
  z-index: 1;
  line-height: 0;
}
div.user {
  color: $base;
  grid-area: right;
  justify-self: end;
  display: flex;
  flex-direction: row;
  align-items: center;
}
div.icon {
  color: $base;
  height: 1.5rem;
  width: 1.5rem;
  padding: 0.25rem 0.25rem 0.25rem 0.25rem;

  span.icon {
    font-awesome-icon,
    svg {
      height: 1rem !important;
      width: 1rem !important;
    }
  }
}
span.label {
  line-height: 1rem;
  padding-right: 0.25rem;

  @media (max-width: 479px) {
    display: none;
  }
}
.logo-wrapper {
  justify-content: center;
  z-index: 1;
  @media (max-width: 479px) {
    display: none;
  }
}

.logo {
  background-repeat: no-repeat;
  background-size: 222px auto;
  display: inline-block;
  outline: none;
  height: clamp(0.63rem, 0.5rem + 0.42vw, 1rem) !important;
  min-width: 195px;
  min-height: 13px;
  @supports (height: round(down, 1px, 1px)) {
    min-height: round(down, clamp(0.63rem, 0.5rem + 0.42vw, 1rem), 1px) !important;
  }

  img {
    height:100%;
  }
}
</style>
